/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Phone from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import omit from 'lodash/omit';
import get from 'lodash/get';
import {
  getCountryCallingCode,
  parseIncompletePhoneNumber,
  parsePhoneNumberFromString,
  formatIncompletePhoneNumber,
} from 'libphonenumber-js/core';

import metadata from '../../metadata.min.json';
import { getCountryCodeByCurrency } from '../auth/selectors';

class InputBasic extends React.PureComponent {
  static propTypes = {
    value: PropTypes.string,
    country: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    metadata: PropTypes.object.isRequired,
    formatter: PropTypes.func,
  };

  static defaultProps = {
    value: '',
    formatter: null,
  };

  onChange = (event) => {
    const [, value] = this.getCallingCodeAndNationalNumber();
    let newValue = parseIncompletePhoneNumber(event.target.value);

    // workaround to remove braces around area codes like (123)
    if (newValue === value) {
      if (this.format(newValue).indexOf(event.target.value) === 0) {
        newValue = newValue.slice(0, -1);
      }
    }

    this.props.onChange(newValue);
  };

  getCallingCodeAndNationalNumber() {
    const { value, country } = this.props;
    const phoneNumber = parsePhoneNumberFromString(value, this.props.metadata);

    if (phoneNumber) {
      return [phoneNumber.countryCallingCode, phoneNumber.nationalNumber];
    }

    const callingCode = getCountryCallingCode(country || 'US', metadata);
    return [callingCode, value];
  }

  format(value) {
    return formatIncompletePhoneNumber(value, this.props.country, this.props.metadata);
  }

  focus = () => {
    this.input.focus();
    this.input.selectionStart = this.props.value.length + 1;
    this.input.selectionsEnd = this.props.value.length + 1;
  };

  storeInput = ref => this.input = ref; // eslint-disable-line no-return-assign

  render() {
    const inputProps = omit(this.props, ['onChange', 'country', 'metadata', 'value', 'dispatch']);
    const [callingCode, value] = this.getCallingCodeAndNationalNumber();
    const formattedCallingCode = `+${callingCode}`;
    const formattedValue = this.format(value);

    return (
      <div>
        <span className={inputProps.className} onClick={this.focus}>
          {formattedCallingCode}
        </span>
        <input
          type="tel"
          autoComplete="tel"
          {...inputProps}
          ref={this.storeInput}
          value={typeof this.props.formatter === 'function' ? this.props.formatter(formattedValue) : formattedValue}
          onChange={this.onChange}
          data-automation-id="input:phoneNumber"
        />
      </div>
    );
  }
}

const CountryCodePhoneInput = ({ disabled, value, onChange, country, ...props }) => {
  const phoneNumber = parsePhoneNumberFromString(value, metadata);
  const parsedCountry = get(phoneNumber, 'country', null);

  return (
    <div className={classNames('country-code-phone-input u-position-relative', { disabled })}>
      <Phone
        {...props}
        disabled={disabled}
        value={value}
        metadata={metadata}
        country={value ? parsedCountry : country}
        countryOptions={['US', 'CA', 'GB', '...']}
        onChange={val => onChange(val || '')}
        inputComponent={InputBasic}
        flagsPath="https://flagicons.lipis.dev/flags/4x3/"
      />
    </div>
  );
};

CountryCodePhoneInput.propTypes = {
  disabled: PropTypes.bool,
  country: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CountryCodePhoneInput.defaultProps = {
  disabled: false,
  country: '',
  value: '',
};

export default connect(
  state => ({
    country: getCountryCodeByCurrency(state),
  })
)(CountryCodePhoneInput);
